/*
  The add-in runs on its own origin, so account links must be resolved against
  the web portal rather than the Office taskpane host.
*/
const PORTAL_BASE_URL = "https://lnf.gr";

export function buildPortalUrl(path: string): string {
  return new URL(path, `${PORTAL_BASE_URL}/`).toString();
}
